// @flow
import * as React from 'react';
import { CheckBox } from 'grommet';
import { CheckboxContext } from './CheckboxContext';


const CheckboxColumn = (row) => {
    const { index } = row;
    const {
        selectAll, selected, onSelect, onUnselect,
    } = React.useContext(CheckboxContext);


    const checked = index in selected;
    const handleChange = () => {
        if (!checked) {
            onSelect(index, row);
        } else {
            onUnselect(index, row);
        }
    };
    React.useEffect(() => {
        if (selectAll) {
            onSelect(index, row);
        } else {
            onUnselect(index, row);
        }
    }, [index, selectAll]);
    return (
        <CheckBox
            type="checkbox"
            id={`id-${index}`}
            name={`checkbox-${index}`}
            onChange={handleChange}
            checked={checked}
            inline
        />
    );
};
export default CheckboxColumn;
